__turbopack_context__.v({
  "collectionLabel": "cW2eta_collectionLabel",
  "favoriteContainer": "cW2eta_favoriteContainer",
  "galleryButton": "cW2eta_galleryButton",
  "gridModal": "cW2eta_gridModal",
  "imageElement": "cW2eta_imageElement",
  "imageElementButton": "cW2eta_imageElementButton" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "imageElementButtonModal": "cW2eta_imageElementButtonModal" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "imageWrapperModal": "cW2eta_imageWrapperModal" + " " + __turbopack_context__.i(248112)["focusWithinOutline"],
  "mainGridWrapper": "cW2eta_mainGridWrapper",
  "playIcon": "cW2eta_playIcon",
  "sentinel": "cW2eta_sentinel",
  "wrapper": "cW2eta_wrapper",
});
